/**
 * @generated SignedSource<<e477804b7a15e3d3b23dd4a95d6fcb19>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomerActivityView_customerAccount$data = {
  readonly customerAccountIdentifier: string;
  readonly id: string;
  readonly " $fragmentType": "CustomerActivityView_customerAccount";
};
export type CustomerActivityView_customerAccount$key = {
  readonly " $data"?: CustomerActivityView_customerAccount$data;
  readonly " $fragmentSpreads": FragmentRefs<"CustomerActivityView_customerAccount">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CustomerActivityView_customerAccount",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerAccountIdentifier",
      "storageKey": null
    }
  ],
  "type": "CustomerAccount",
  "abstractKey": null
};

(node as any).hash = "5144344fb59215ba14fac40650cf776c";

export default node;
